import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { CircularProgress } from "@mui/material";
import {
  changeOrderSearchType,
  getMainOrdersSummary,
} from "../redux/actions/orderActions";
import PageCard from "../components/PageCard";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import ReplyAllIcon from "@mui/icons-material/ReplyAll";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";

const MainPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loginInfo } = useSelector((state) => state.userLogin);

  const { loadingMainOrdersSummary, mainOrdersSummary } = useSelector(
    (state) => state.mainOrdersSummary
  );

  const openOrders = (type) => {
    dispatch(changeOrderSearchType(type));
    navigate("/orders");
  };

  useEffect(() => {
    dispatch(getMainOrdersSummary(loginInfo.BranchID));
  }, []);

  return (
    <div className="main-page">
      {loadingMainOrdersSummary ? (
        <CircularProgress style={{ margin: "auto" }} />
      ) : (
        <>
          <Row style={{ margin: "10px auto" }}>
            <Col xs={12} sm={6} md={6} className="pb-2">
              <div
                className="d-flex flex-row p-2 my-2 mx-auto align-items-center"
                style={{
                  borderRadius: "5px",
                  justifyContent: "space-between",
                  backgroundColor: "var(--primary-color)",
                }}
              >
                <div className="d-flex flex-column">
                  <h5 style={{ color: "white" }}>إجمالي الطلبيات</h5>
                  <strong
                    style={{
                      fontSize: 18,
                      marginRight: "10px",
                      color: "white",
                    }}
                  >
                    {mainOrdersSummary
                      ? mainOrdersSummary.kind1[0].Total_k1 || 0
                      : 0}
                  </strong>
                </div>
                <EqualizerIcon style={{ fontSize: "40px", color: "white" }} />
              </div>
            </Col>
            <Col xs={12} sm={6} md={6}>
              <div
                className="d-flex flex-row p-2 my-2 mx-auto align-items-center"
                style={{
                  borderRadius: "5px",
                  justifyContent: "space-between",
                  backgroundColor: "var(--primary-color)",
                }}
              >
                <div className="d-flex flex-column">
                  <h5 style={{ color: "white" }}>المحفظة</h5>
                  <strong
                    style={{
                      fontSize: 18,
                      marginRight: "10px",
                      color: "white",
                    }}
                  >
                    {mainOrdersSummary
                      ? mainOrdersSummary.kind1[0].almahfaza
                        ? parseFloat(
                            mainOrdersSummary.kind1[0].almahfaza || 0
                          ).toLocaleString("en-GB")
                        : 0
                      : 0}
                  </strong>
                </div>
                <AttachMoneyIcon style={{ fontSize: "40px", color: "white" }} />
              </div>
            </Col>
          </Row>
          <Row style={{ margin: "10px auto" }}>
            <Col sm={12} md={6} lg={6} xxl={3}>
              <PageCard
                name={"اليوم"}
                number={
                  mainOrdersSummary
                    ? mainOrdersSummary.kind1[0].Count_todayk1 || 0
                    : 0
                }
                image={
                  <AccessTimeIcon
                    style={{ fontSize: "60px", color: "var(--primary-color)" }}
                  />
                }
                handleClick={() => openOrders("today")}
              />
            </Col>
            <Col sm={12} md={6} lg={6} xxl={3}>
              <PageCard
                name={"تحت الإجراء"}
                number={
                  mainOrdersSummary
                    ? mainOrdersSummary.kind1[0].Count_case1k1 || 0
                    : 0
                }
                image={
                  <ManageHistoryIcon
                    style={{ fontSize: "60px", color: "var(--primary-color)" }}
                  />
                }
                handleClick={() => openOrders("proccessing")}
              />
            </Col>
            <Col sm={12} md={6} lg={6} xxl={3}>
              <PageCard
                name={"قيد الشحن"}
                number={
                  mainOrdersSummary
                    ? mainOrdersSummary.kind1[0].Count_case3k1 || 0
                    : 0
                }
                image={
                  <LocalShippingIcon
                    style={{ fontSize: "60px", color: "var(--primary-color)" }}
                  />
                }
                handleClick={() => openOrders("shipping")}
              />
            </Col>
            <Col sm={12} md={6} lg={6} xxl={3}>
              <PageCard
                name={"تم تسليمها"}
                number={
                  mainOrdersSummary
                    ? mainOrdersSummary.kind1[0].Count_case4k1 || 0
                    : 0
                }
                image={
                  <ShoppingBagIcon
                    style={{ fontSize: "60px", color: "var(--primary-color)" }}
                  />
                }
                handleClick={() => openOrders("delivered")}
              />
            </Col>
            <Col sm={12} md={6} lg={6} xxl={3}>
              <PageCard
                name={"راجع"}
                number={
                  mainOrdersSummary
                    ? mainOrdersSummary.kind1[0].Count_case7k1 || 0
                    : 0
                }
                image={
                  <ReplyAllIcon
                    style={{ fontSize: "60px", color: "var(--primary-color)" }}
                  />
                }
                handleClick={() => openOrders("returnedBack")}
              />
            </Col>
            <Col sm={12} md={6} lg={6} xxl={3}>
              <PageCard
                name={"تم الإسترداد"}
                number={
                  mainOrdersSummary
                    ? mainOrdersSummary.kind1[0].Count_case10k1 || 0
                    : 0
                }
                image={
                  <SettingsBackupRestoreIcon
                    style={{ fontSize: "60px", color: "var(--primary-color)" }}
                  />
                }
                handleClick={() => openOrders("returned")}
              />
            </Col>
            <Col sm={12} md={6} lg={6} xxl={3}>
              <PageCard
                name={"تم تسويتها"}
                number={
                  mainOrdersSummary
                    ? mainOrdersSummary.kind1[0].Count_case5k1 || 0
                    : 0
                }
                image={
                  <TaskAltIcon
                    style={{ fontSize: "60px", color: "var(--primary-color)" }}
                  />
                }
                handleClick={() => openOrders("done")}
              />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default MainPage;
